import React from "react";
import { Column, Row, Sheet, Text } from "@amzn/meridian";
import PillButton from "src/components/UI/PillButton";
import "./ConfirmContainerCountSheet.scss";

interface ConfirmContainerCountSheetProps {
  open: boolean;
  /** Number of containers scanned so far (matches the header count). */
  count: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmContainerCountSheet: React.FC<ConfirmContainerCountSheetProps> = ({
  open,
  count,
  onConfirm,
  onCancel,
}) => {
  return (
    <Sheet type="overlay" side="bottom" open={open} onClose={onCancel}>
      <Column spacing="400" spacingInset="500">
        <Text type="h300">Confirm Container Count</Text>

        <Text type="h100" color="primary">
          {count} {count === 1 ? "container was" : "containers were"} scanned.
        </Text>

        <Text type="b200" color="secondary">
          Please verify and confirm that all required containers have been scanned.
        </Text>

        <Row
          className="confirm-count-sheet__actions"
          spacing="300"
          widths={["fit", "fill"]}
          alignmentVertical="stretch"
        >
          <PillButton text="CANCEL" color="outline" onClick={onCancel} />
          <PillButton text={`CONFIRM ONLY ${count}`} color="primary" disabled={count === 0} onClick={onConfirm} />
        </Row>
      </Column>
    </Sheet>
  );
};

export default ConfirmContainerCountSheet;
